export enum Breakpoints {
  Mobile = 550,
  Tablet = 995,
  Desktop = 1024,
}
